module.exports = __webpack_public_path__ + "static/img/13areaB_1.a756f67.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_1.png
// module id = 1108
// module chunks = 1